import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'
import { gad7_catalog } from '../../../../escalas/gad7/gad7.catalog'
import { IMAGE_API, myHospitals } from '../../../../resources'

const gad7_values = [
    "Ningún día",
    "Varios días",
    "Más de la mitad de los días",
    "Casi todos los días"
]

function getGad7Interpretation(score) {
    if (score <= 4) return 'Ansiedad mínima'
    if (score <= 9) return 'Ansiedad leve'
    if (score <= 14) return 'Ansiedad moderada'
    return 'Ansiedad severa'
}

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        alignItems: 'flex-end',
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050',
    },
    subtitle: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050',
    },
    infoRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12,
    },
    scoreBox: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#e6f4ff',
        padding: 8,
        borderRadius: 6,
        marginBottom: 10,
    },
    scoreText: {
        fontWeight: 700,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 6,
        borderRadius: 4,
    },
    rowEven: {
        backgroundColor: '#f5f5f5',
    },
    question: {
        width: '70%',
    },
    answer: {
        width: '28%',
        textAlign: 'right',
    },
})

export default function Gad7PDF({ pacienteData, fecha, gad7 = [] }) {
    const score = gad7.reduce((a, v) => a + v, 0)

    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header}>
                    <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                    <View style={styles.headerRight}>
                        <Text style={styles.title}>Escala GAD-7</Text>
                        {fecha && <Text style={styles.subtitle}>{new Date(fecha).toLocaleDateString('es-MX')}</Text>}
                    </View>
                </View>

                <View style={styles.infoRow}>
                    <Text>Paciente: {pacienteData?.name || '-'}</Text>
                </View>

                <View style={styles.scoreBox}>
                    <Text style={styles.scoreText}>Puntuación total: {score} / 21</Text>
                    <Text style={styles.scoreText}>{getGad7Interpretation(score)}</Text>
                </View>

                {
                    gad7_catalog.map((item, index) => (
                        <View key={index} style={index % 2 === 0 ? [styles.row, styles.rowEven] : styles.row}>
                            <Text style={styles.question}>{item}</Text>
                            <Text style={styles.answer}>{gad7_values[gad7[index]]}</Text>
                        </View>
                    ))
                }
            </Page>
        </Document>
    )
}
